import Joi from 'joi';

import {constantsRegex} from "../constants/constants.regex";

export const editProfileCustomerValidator = Joi.object({
    last_name: Joi.string().required().optional().messages({
        'string.empty': 'Заповніть це поле',
    }),
    first_name: Joi.string().required().optional().messages({
        'string.empty': 'Заповніть це поле',
    }),
    email: Joi.string().required().pattern(constantsRegex.EMAIL).optional().messages({
        'string.empty': 'Заповніть це поле',
        'string.pattern.base': 'Невалідний email',
    }),
    mobile_nummer: Joi.string().required().optional().messages({
        'string.empty': 'Заповніть це поле',
    }),
    address: Joi.string().allow('').optional().allow(null),
    apartment_number: Joi.string().allow('').optional().allow(null),
    house_number: Joi.string().allow('').optional().allow(null),

    password: Joi.string().allow('').min(8).optional().messages({
        'string.min': 'Не менше 8 символів'
    }),
    confirm_password: Joi.string().min(8).valid(Joi.ref('password')).optional().messages({
        'string.empty': 'Заповніть це поле',
        'string.min': 'Не менше 8 символів',
        'any.only': 'Паролі не збігаються',
    })
});
